import React, { FC } from 'react';
import { MarkdownUtil } from 'util/markdown/MarkdownUtil';

interface MarkdownProps {
  children: string
  className?: string
}

export const Markdown: FC<MarkdownProps> = ({children, className}) => {
  const html = MarkdownUtil.toHtml(children);

  return <div className={className} dangerouslySetInnerHTML={{__html: html}} />;
}